module.exports = __webpack_public_path__ + "static/media/typec.4121159b.jpg";